import React from 'react';

export const Skeleton = ({ className = '', as: Component = 'div', ...props }) => {
  return <Component className={`skeleton ${className}`} {...props} />;
};

export const SkeletonText = ({ lines = 3, className = '' }) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        className={`h-3 ${i === lines - 1 ? 'w-3/5' : 'w-full'}`}
      />
    ))}
  </div>
);

export const SkeletonCircle = ({ size = 40, className = '' }) => (
  <Skeleton
    className={`rounded-full ${className}`}
    style={{ width: size, height: size }}
  />
);

/** Row skeleton for table loading placeholders */
export const SkeletonRow = ({ columns = 4 }) => (
  <tr className="border-b last:border-b-0 border-slate-100">
    {Array.from({ length: columns }).map((_, i) => (
      <td key={i} className="py-3 px-4">
        <Skeleton className="h-3 w-3/4" />
      </td>
    ))}
  </tr>
);

export default Skeleton;
